export * from './offers-databack-management.page';

export * from './tabs';
